



























import Component from 'vue-class-component'
import { BaseComponent } from '@/shared/components/base-component'
import { Injector } from '@/config/dependency-injection'
import { SharedModule } from '@/shared/store/shared-module'
import { LookupItem } from '@/api/generated'
import { StringMap } from '@/shared/utils/map'
import { Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'respondeco-category-filter',
})
export default class RespondecoCategoryFilter extends BaseComponent {
  @Prop({
    type: Object,
  })
  public readonly value!: StringMap<boolean>

  public categories: StringMap<boolean> = {}

  private sharedModule = Injector.get(SharedModule)

  get lookupCategories(): LookupItem[] {
    return this.sharedModule.data.categories
  }

  public mounted() {
    this.sharedModule.fetchLookupCategories().then(() => {
      this.initialiseFilters()
    })
  }

  public reset(): void {
    this.$emit('input', {})

    this.initialiseFilters()
  }

  public toggleCategory(key: number): void {
    this.categories[key] = !this.categories[key]

    this.$emit('input', this.categories)
  }

  @Watch('value')
  public valueUpdated(newValue: StringMap<boolean>) {
    this.categories = newValue
  }

  private initialiseFilters() {
    this.categories = {}

    for (const category of this.lookupCategories) {
      this.$set(this.categories, category.key, false)
    }
  }
}
